import { BaseEntity } from "@app/models/rest/base-entity";
import {
  HateoasProjection,
  HateoasResource
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("teams")
export class Team extends BaseEntity {
  name: string;
  imageUrl: string;
}

@HateoasProjection(Team, "detail")
export class TeamBasicProjection extends BaseEntity {
  name: string;
  imageUrl: string;
}
